import React from 'react';
import { Typography } from '@mui/material';

import Styles from './TravelGraphsHeading.module.scss';

interface Props {
  heading: string;
}

const TravelGraphsHeading: React.FC<Props> = ({ heading }) => (
  <Typography className={Styles.travelGraphsHeading} variant="title3">
    {heading}
  </Typography>
);

export default TravelGraphsHeading;
